var styles = {"box":"Submit_box_syowp_1","searchable":"Submit_searchable_syowp_23","small":"Submit_small_syowp_27"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
